/* eslint-disable import/no-cycle */
import {executeGet} from '../requests';

const resourcesName = 'v1/workplaces';

export const RelevantMessagesApi = {
  all: (params) => executeGet(`${resourcesName}/${params.id}/relevant-messages`),
};
